import React from "react";
import { motion } from "framer-motion";
import { GraduationCap, Code, Cpu } from "lucide-react";

const Banner = ({ page, path }) => {
  return (
    <div className="relative flex items-center justify-center h-[180px] md:h-[280px] overflow-hidden">
      {/* Background Gradient */}
      <div className="absolute inset-0 bg-gradient-to-r from-[#0e2a46] via-[#1e3a8a] to-[#0e2a46] opacity-95"></div>

      {/* Floating Tech Icons */}
      <motion.div
        animate={{ y: [0, -15, 0] }}
        transition={{ repeat: Infinity, duration: 5 }}
        className="absolute top-10 left-10 hidden md:block text-white opacity-30"
      >
        <GraduationCap size={48} />
      </motion.div>

      <motion.div
        animate={{ y: [0, 15, 0] }}
        transition={{ repeat: Infinity, duration: 6 }}
        className="absolute bottom-10 right-10 hidden md:block text-white opacity-30"
      >
        <Cpu size={48} />
      </motion.div>

      <motion.div
        animate={{ x: [0, 20, 0] }}
        transition={{ repeat: Infinity, duration: 4 }}
        className="absolute top-1/3 right-1/3 hidden md:block text-white opacity-30"
      >
        <Code size={48} />
      </motion.div>

      {/* Glassmorphic Content Card */}
      <div className="relative px-6 py-4 md:px-10 md:py-6 bg-white/10 backdrop-blur-md rounded-2xl shadow-lg text-center border border-white/20">
        <motion.p
          initial={{ opacity: 0, y: 15 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-white text-[28px] md:text-[58px] font-extrabold tracking-wide drop-shadow-lg"
        >
          {page}
        </motion.p>
        <motion.p
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.6 }}
          className="text-gray-200 font-medium text-[14px] md:text-[18px]"
        >
          <span className="text-[#FC6441] font-bold">/ </span>
          {path}
        </motion.p>
      </div>

      {/* Radial Glow Effect */}
      <div className="absolute w-[500px] h-[500px] bg-white/10 rounded-full blur-3xl opacity-20"></div>
    </div>
  );
};

export default Banner;
